// @ts-nocheck
import { Column } from 'react-table'
import { PaymentInfoCell } from './PaymentInfoCell'
import { PaymentActionsCell } from './PaymentActionsCell'
import { PaymentSelectionCell } from './PaymentSelectionCell'
import { PaymentCustomHeader } from './PaymentCustomHeader'
import { PaymentSelectionHeader } from './PaymentSelectionHeader'
import { Payment } from '../../core/_models'
import { FormattedMessage } from 'react-intl'

const paymentsColumns: ReadonlyArray<Column<Payment>> = [
  {
    Header: (props) => <PaymentSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({ row }) => <PaymentSelectionCell id={row.original.id} />,
  },
  {
    Header: (props) => (
      <PaymentCustomHeader
        tableProps={props}
        title={<FormattedMessage id='PAYMENT.TABLE.COLUMN.RESELLER' defaultMessage='Reseller' />}
        className='min-w-125px'
      />
    ),
    id: 'reseller_name',
    accessor: (row) => row.reseller?.reseller_name || 'N/A',
  },
  {
    Header: (props) => (
      <PaymentCustomHeader
        tableProps={props}
        title={<FormattedMessage id='PAYMENT.TABLE.COLUMN.PAYMENTMETHOD' defaultMessage='Payment Method' />}
        className='min-w-125px'
      />
    ),
    id: 'payment_method_name',
    accessor: (row) => row.payment_method?.method_name || 'N/A',
  },
  {
    Header: (props) => (
      <PaymentCustomHeader
        tableProps={props}
        title={<FormattedMessage id='PAYMENT.TABLE.COLUMN.AMOUNT' defaultMessage='Amount' />}
        className='min-w-100px'
      />
    ),
    id: 'amount',
    accessor: 'amount',
  },
  {
    Header: (props) => (
      <PaymentCustomHeader
        tableProps={props}
        title={<FormattedMessage id='PAYMENT.TABLE.COLUMN.CURRENCY' defaultMessage='Currency' />}
        className='min-w-100px'
      />
    ),
    id: 'currency_code',
    accessor: (row) => row.currency?.code || 'N/A',
  },
  {
    Header: (props) => (
      <PaymentCustomHeader
        tableProps={props}
        title={<FormattedMessage id='PAYMENT.TABLE.COLUMN.REMAININGPAYMENTAMOUNT' defaultMessage='Remaining Payment Amount' />}
        className='min-w-100px'
      />
    ),
    id: 'remaining_payment_amount',
    accessor: 'remaining_payment_amount',
  },
  {
    Header: (props) => (
      <PaymentCustomHeader
        tableProps={props}
        title={<FormattedMessage id='PAYMENT.TABLE.COLUMN.STATUS' defaultMessage='Status' />}
        className='min-w-100px'
      />
    ),
    id: 'status',
    accessor: 'status',
    Cell: ({ value }) => {
      const renderStatusBadge = () => {
        switch (value) {
          case 'completed':
            return <span className="badge badge-success">تکمیل</span>
          case 'pending':
            return <span className="badge badge-warning">درحال انتظار</span>
          case 'failed':
            return <span className="badge badge-danger">ناموفق</span>
          case 'rollback':
            return <span className="badge badge-info">کنسل و یا بازگشت شد</span>
          case 'void':
            return <span className="badge badge-secondary">Voided</span>
          default:
            return <span className="badge badge-light">نامعلوم</span>
        }
      }
      return renderStatusBadge()
    },
  },
  {
    Header: (props) => (
      <PaymentCustomHeader
        tableProps={props}
        title={<FormattedMessage id='PAYMENT.TABLE.COLUMN.NOTES' defaultMessage='Notes' />}
        className='min-w-150px'
      />
    ),
    id: 'notes',
    accessor: 'notes',
  },
  {
    Header: (props) => (
      <PaymentCustomHeader
        tableProps={props}
        title={<FormattedMessage id='PAYMENT.TABLE.COLUMN.PAYMENTDATE' defaultMessage='Payment Date' />}
        className='min-w-150px'
      />
    ),
    id: 'payment_date',
    accessor: 'payment_date',
  },
  {
    Header: (props) => (
      <PaymentCustomHeader
        tableProps={props}
        title={<FormattedMessage id='TABLE.GENERAL.ACTION' defaultMessage='Action' />}
        className='text-end min-w-100px'
      />
    ),
    id: 'actions',
    Cell: ({ row }) => <PaymentActionsCell id={row.original.id} status={row.original.status} />, // Sending Status to PaymentActionsCell
  },
]

export { paymentsColumns }
